/**
 * Rangement local du navigateur, pour les petites valeurs : jetons de session,
 * préférences, instantané du compte.
 *
 * Même signature asynchrone que sur le mobile (trousseau, Keystore) : le code qui
 * s'en sert est identique des deux côtés. Un stockage muet (navigation privée,
 * quota atteint, cookies bloqués) n'est pas une panne : on continue sans
 * persistance, l'application redemandera simplement ce qu'elle ne retrouve pas.
 *
 * Toutes les clés sont préfixées `bul.`.
 */
function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export const deviceStorage = {
  async read(key: string): Promise<string | null> {
    try {
      return storage()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },

  async write(key: string, value: string): Promise<void> {
    try {
      storage()?.setItem(key, value);
    } catch {
      // Quota atteint ou stockage refusé : la valeur vivra le temps de l'onglet.
    }
  },

  async remove(key: string): Promise<void> {
    try {
      storage()?.removeItem(key);
    } catch {
      // Idem.
    }
  },

  /** Lecture synchrone, pour ce qui doit être connu avant le premier rendu. */
  readNow(key: string): string | null {
    try {
      return storage()?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
};
